export const challengeTaskDtoFields = [{
        name: "order",
        title: "Order",
        render: (record) => record.challengeTask.order
    }, {
        name: "name",
        title: "Name",
        render: (record) => record.challengeTask.name
    }, {
        name: "points",
        title: "Points",
        render: (record) => record.challengeTask.points
    }, {
        name: "sample",
        title: "Sample",
        render: (record) => `<i class="material-icons">${record.challengeTask.sample === 1 ? "check" : ""}</i>`
    }];
